import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import { MdListAlt, MdVolunteerActivism, MdWhatsapp } from "react-icons/md";

export default function IntroPara(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-primary"
				style={{
					paddingTop: "70px",
					paddingBottom: "70px"
				}}
			>
				
				<div className="container">
					<div className="row" >

						<div className="col-md-12 text-center">
							<h6
								style={{
									fontSize: "20px"
								}}
								className="font-light mb-5"
							>
								Every child deserves the opportunity to <b>dream, learn, and thrive.</b>
							</h6>
							
							<h6
								style={{
									fontSize: "32px"
								}}
								className="font-bold"
							>
								Tanzania Children Hope Innovations (TCHI) empowers communities to support vulnerable children and families through sustainable, locally driven solutions. 
							</h6>

							<h6
								style={{
									fontSize: "28px"
								}}
								className="font-light  my-5"
							>
								Join us in creating lasting impact. Your support today can transform lives.
							</h6>
						</div>

						<div className="col-md-12 text-center mt-4">
							<button	
								style={{
									margin: "10px"
								}}
								className="btn btn-padded btn-outline-light btn-rounded"
								onClick={() => {
									appContext.navTo({
										item: 'donations'
									})
								}}
							>
								<MdVolunteerActivism size={32}/> DONATE
							</button>
						</div>

						
					</div>

				
				</div>
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
